import { jsx as c } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ c(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: /* @__PURE__ */ c(
      "path",
      {
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5.69 12.918c.816-.352 1.054-1.719.536-3.052C5.79 8.742 4.955 8 4.216 8q-.21 0-.406.082c-.816.352-1.054 1.719-.536 3.052C3.71 12.258 4.544 13 5.283 13q.211 0 .407-.082M14.7 13.5c-1.1-2-1.441-2.5-2.7-2.5s-1.736.755-2.836 2.747c-.942 1.703-2.846 1.845-3.321 3.291-.097.265-.145.677-.143.962 0 1.176.787 2 1.8 2 1.259 0 3-1 4.5-1s3.24 1 4.5 1c1.013 0 1.8-.823 1.8-2 0-.285-.05-.697-.146-.962-.475-1.451-2.512-1.835-3.454-3.538M9.474 9c.055 0 .11 0 .163-.011.944-.128 1.533-1.346 1.32-2.722C10.754 4.97 9.91 4 9.025 4c-.055 0-.109 0-.163.011-.944.128-1.533 1.346-1.32 2.722C7.746 8.026 8.59 9 9.475 9zM16.456 6.733c.214-1.376-.375-2.594-1.32-2.722A1 1 0 0 0 14.974 4c-.885 0-1.728.97-1.93 2.267-.214 1.376.375 2.594 1.32 2.722q.081.01.162.011c.885 0 1.73-.974 1.93-2.267M20.188 8.082A1 1 0 0 0 19.782 8h-.015c-.735.012-1.56.75-1.993 1.866-.519 1.335-.28 2.7.538 3.052q.196.082.406.082c.74 0 1.575-.742 2.011-1.866.516-1.335.272-2.7-.54-3.052"
      }
    )
  }
);
export {
  t as default
};
